export enum EntityType {
    EQUIPMENT = 'EQUIPMENT',
    COLLECTION = 'COLLECTION',
    LOCATION = 'LOCATION',
    POINT = 'POINT',
    UNKNOWN = 'UNKNOWN'
}

export interface EntityParam {
    siteId: string;
    customerId: string;
    entityIds: string[];
    entityType: EntityType;
}
